import React from "react";
import type { LayoutConfig, BreadcrumbItem } from "@ms/shared-components";
import { ROUTE_CONFIG } from "./routeConfig";

// 导航函数类型
type NavigateFunction = (path: string) => void;

// 创建布局配置的函数，只负责主框架的显示配置
const createMsAdminLayoutConfig = (navigate: NavigateFunction, currentPath: string = "/services"): LayoutConfig => {
  // 根据当前路径生成面包屑
  const generateBreadcrumbs = (path: string): BreadcrumbItem[] => {
    const route = ROUTE_CONFIG.find((r) => r.path === path);
    if (route) {
      return [{ title: "首页", href: "/" }, { title: route.breadcrumb }];
    }

    return [{ title: "首页", href: "/" }, { title: "微服务管理" }];
  };

  return {
    // 系统信息（不设 logo，使用文字标题，避免生产环境路径导致图片加载失败）
    system: {
      name: "微服务管理",
      shortName: "微服务管理",
    },

    // 面包屑配置
    breadcrumbs: generateBreadcrumbs(currentPath),

    // 菜单配置 - 由路由配置提供，这里不生成菜单项
    menuItems: [],

    // 顶部右侧按钮 - 添加调试工具
    // headerActions: [
    //   {
    //     key: "debug-tool",
    //     icon: React.createElement("span", {}, "🐛"),
    //     label: "调试工具",
    //     onClick: () => {
    //       // 调试工具点击事件，由 PermissionDebugTool 组件处理
    //       console.log("调试工具被点击");
    //     },
    //   },
    // ],

    // 样式配置：尽量使用 MainLayout 默认样式，仅保留主题色
    styles: {
      primaryColor: "#1890ff",
    },
  };
};

// 默认导出，用于向后兼容
const msAdminLayoutConfig = createMsAdminLayoutConfig(() => {
  console.warn("导航函数未提供，使用默认行为");
});

// 页脚信息
export const footerConfig = {
  copyright: "管理员管理系统",
  company: "idTree微服务平台",
};

// 导出配置创建函数和默认配置
export { createMsAdminLayoutConfig };
export default msAdminLayoutConfig;
